import { httpClient } from '@/httpClient/axios.ts';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import Cookies from 'js-cookie';
import { useState } from 'react';
import * as Sentry from '@sentry/browser';

export interface Feedback {
  reason: number;
  other_reason_details: string;
  event: string;
}

export type TransmissionStates = 'unknown' | 'sending' | 'done' | 'error';

export const useTransmitFeedback = () => {
  const meta = useAppConfig();
  const SPINNER_DURATION = 1000; // One second
  const [transmitStatus, setTransmitStatus] = useState<TransmissionStates>('unknown');

  const transmitFeedback = async (feedback: Feedback) => {
    const headers = {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    };
    if (!meta) {
      return Promise.reject();
    }
    const url = meta.api.feedback;

    setTransmitStatus('sending');

    return httpClient
      .post(url, feedback, {
        headers: headers,
      })
      .then(() => {
        setTimeout(() => {
          setTransmitStatus('done');
        }, SPINNER_DURATION);
      })
      .catch((e) => {
        console.error('Feedback transmission failed, because the backend had an Error');
        Sentry.captureException(e);
        setTimeout(() => {
          setTransmitStatus('error');
        }, SPINNER_DURATION);
      });
  };

  return { transmitStatus, transmitFeedback };
};
